export default {
    computed: {
        $reviewStore() {
            return this.$store.state.review;
        },
    },
};